import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@api/services/api/api.service';
import { OutputAdapterService } from '@core/modules/api/services/output-adapter/output-adapter.service';
import { InputAdapterService } from '@core/modules/api/services/input-adapter/input-adapter.service';
import { HttpReqService } from '@core/modules/api/services/http-req/http-req.service';

@Injectable({
  providedIn: 'root'
})
export class ApiCustomService extends ApiService {
  constructor(
    protected http: HttpClient,
    protected outputAdapter: OutputAdapterService,
    protected inputAdapter: InputAdapterService,
    protected httpReqService: HttpReqService
  ) {
    super(http, outputAdapter, inputAdapter, httpReqService);
  }
}
